import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaArrowLeft } from 'react-icons/fa';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const CheckEmail = () => {
  return (
    <>
      <Header />
      <div className="container-fluid d-flex align-items-center justify-content-center bg-light" style={{ minHeight: 'calc(100vh - 200px)', paddingTop: '10rem', paddingBottom: '8rem' }}>
        <div className="card shadow-sm p-4 p-md-5" style={{ maxWidth: '500px', width: '100%' }}>
          <div className="text-center mb-4">
            <FaEnvelope className="text-primary" style={{ fontSize: '4rem' }} />
          </div>
          
          <h1 className="text-center h3 mb-4">Check Your Email</h1>
          
          <p className="text-muted text-center mb-4">
            We've sent a verification link to your email address. 
            Please check your inbox and click the link to verify your account.
            If you don't see the email, please check your spam folder.
          </p>

          <div className="text-center">
            <Link to="/login" className="btn btn-link text-primary text-decoration-none">
              <FaArrowLeft className="me-2" />
              Back to Login
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CheckEmail; 